import React, { useEffect, useMemo, useState } from 'react'
import { Html, Line } from '@react-three/drei'
import { params } from '../../../../../redux/reducers/reducer';

const OutLineSection = ({ leftWrapSize, rightWrapSize, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV }) => {
    

    const offsetCB = 0.2;
    const offsetHor = 0.15;
    const offsetVer = 0.2;

    const topLinePoints = useMemo(() => (
            [
                [-(params.leanF_p_d / 2 + overHangWidth), params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, (params.p_d / 2 + offsetCB)],
                //right part
                [params.leanF_p_d / 2 + overHangWidth, params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, params.p_d / 2 + offsetCB],
                [params.leanF_p_d / 2 + rightWrapSize + overHangWidth, params.leanF_p_h  + offsetHor, params.p_d / 2 + params.leanF_p_w + overHangLength],
                [params.leanF_p_d / 2 + rightWrapSize + overHangWidth, params.leanF_p_h - offSetRoofTrussV, params.p_d / 2 + params.leanF_p_w + overHangLength],
                [params.leanF_p_d / 2 + rightWrapSize + overHangWidth - (offSetRoofTrussH + 0.5), params.leanF_p_h - offSetRoofTrussV, params.p_d / 2 + params.leanF_p_w + overHangLength - offSetRoofTrussH],
                [params.leanF_p_d / 2 + rightWrapSize + overHangWidth - (offSetRoofTrussH + 0.5), 0.2, params.p_d / 2 + params.leanF_p_w + overHangLength - offSetRoofTrussH],
                //left part
                [-(params.leanF_p_d / 2 + leftWrapSize + overHangWidth - (offSetRoofTrussH + 0.5)), 0.2, params.p_d / 2 + params.leanF_p_w + overHangLength - offSetRoofTrussH],
                [-(params.leanF_p_d / 2 + leftWrapSize + overHangWidth - (offSetRoofTrussH + 0.5)), params.leanF_p_h - offSetRoofTrussV, params.p_d / 2 + params.leanF_p_w + overHangLength - offSetRoofTrussH],
                [-(params.leanF_p_d / 2 + leftWrapSize + overHangWidth), params.leanF_p_h - offSetRoofTrussV, params.p_d / 2 + params.leanF_p_w + overHangLength],
                [-(params.leanF_p_d / 2 + leftWrapSize + overHangWidth), params.leanF_p_h  + offsetHor, params.p_d / 2 + params.leanF_p_w + overHangLength],
                [-(params.leanF_p_d / 2 + overHangWidth), params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, params.p_d / 2 + offsetCB],
            ]
    ), [params.leanF_p_d, params.p_d, params.leanF_p_w, params.leanF_p_h, params.b_l_t_r_pF, overHangWidth, overHangLength, offSetRoofTrussH, offSetRoofTrussV, rightWrapSize, leftWrapSize])

    

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Html occlude position={[0, params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + 0.5 , params.p_d / 2 + 0.5]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection